module.exports = __webpack_public_path__ + "img/prod_info_cyt.f4b59c0f.png";